export var Resolutions = {
    SD: {
        minHeight: 1,
        minWidth: 1
    },
    HD: {
        minHeight: 720,
        minWidth: 1280
    },
    UHD: {
        minHeight: 2160,
        minWidth: 3840
    }
};

//# sourceMappingURL=resolution.js.map